/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {  array, string } from 'prop-types';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import mbpLogger from 'mbp-logger';
import { format } from 'date-fns';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { GRAPHQL_ENV } from '../../../../../../../gql';
import PDPAddonUI from './PDPAddonUI';
import findAddOnsAndContent from '../../../../../../../gql/queries/findAddOnsAndContent';
import GenericSkeleton from '../../../../../GraphqlSkeletonComponents/GenericSkeleton';
import PDPAddonMessage from './PDPAddonMessage';

const PDPAddonContainer = ({
    zipCode, categoryId, productCode, selectedDate, productBaseCode, pdpContent,
}) => {
    const brand = useSelector(getBrand);
    const formatDate = (dateString) => {
        const today = new Date();

        if (dateString.toLowerCase() === 'today') {
            return today.toISOString().split('T')[0]; // "2025-08-22"
        }

        if (dateString.toLowerCase() === 'tomorrow') {
            const tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 1);
            return tomorrow.toISOString().split('T')[0]; // "2025-08-23"
        }

        // If it's already a proper date string, return as-is
        return dateString;
    };
    let dateToFormat = formatDate(selectedDate);

    if (typeof dateToFormat === 'string') {
        // date can come in as either a string or an actual date obj.
        // if it's a string, need to change date format to use / instead of - to be properly parsed in all browsers
        dateToFormat = dateToFormat.split('-').join('/');
    }
    const deliveryDate = dateToFormat ? format(new Date(dateToFormat), 'MM/dd/yyyy') : '';

    const ADD_ON_AND_CONTENT_QUERY = findAddOnsAndContent();

    const { loading: addOnLoading, error: addOnError, data: addOnData } = useQuery(ADD_ON_AND_CONTENT_QUERY, {
        variables: {
            brand: brand?.domain,
            locale: 'en-us',
            environment: GRAPHQL_ENV,
            zipCode,
            deliveryDate,
            categoryId,
            productBaseCode,
            productSku: productCode,
            query: '',
        },
    });

    if (addOnLoading) {
        return  <GenericSkeleton height="116px" />;
    }
    if (addOnError) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: ADD_ON_AND_CONTENT_QUERY,
            jsError: addOnError,
            component: 'PDPAddonContainer.js',
            message: `Failed to fetch content data on brand ${brand?.domain}`,
        });
        return null;
    }

    const { findAddonsAndContent: addOnDataFromCombinedQuery } = addOnData;
    const content = addOnDataFromCombinedQuery?.addonGroups || [];
    const addOnHoverInfo = addOnDataFromCombinedQuery?.content?.entries || [];
    return (
        content.length > 0
            ? (
                <PDPAddonUI
                    content={content}
                    addOnHoverInfo={addOnHoverInfo}
                />
            ) : <PDPAddonMessage pdpContent={pdpContent} />

    );
};

PDPAddonContainer.propTypes = {
    selectedDate: string.isRequired,
    zipCode: string.isRequired,
    categoryId: string.isRequired,
    productCode: string.isRequired,
    productBaseCode: string.isRequired,
    pdpContent: array.isRequired,
};

export default PDPAddonContainer;
